import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PhoneInput from "react-phone-number-input/input";
import React, { useMemo } from "react";
import classNames from "classnames";
import { getClassNameFactory } from "../../utilities/classNames";
import InlineErrorMessage from "../../elements/InlineErrorMessage";
import { usePhoneNumberInputValidation } from "./PhoneNumberInputHooks";
import { DISPLAY_CLASS_NAME, defaultErrors, defaultForceShowError } from "./PhoneNumberInputConstants";
export var PhoneNumberInput = function PhoneNumberInput(_ref) {
  var className = _ref.className,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? defaultErrors : _ref$errors,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      onBlur = _ref.onBlur,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disableValidatio = _ref.disableValidation,
      disableValidation = _ref$disableValidatio === void 0 ? false : _ref$disableValidatio,
      _ref$forceShowError = _ref.forceShowError,
      forceShowError = _ref$forceShowError === void 0 ? defaultForceShowError : _ref$forceShowError,
      props = _objectWithoutProperties(_ref, ["className", "errors", "id", "label", "onChange", "value", "onBlur", "required", "disableValidation", "forceShowError"]);

  var getClassName = getClassNameFactory(DISPLAY_CLASS_NAME);

  var _usePhoneNumberInputV = usePhoneNumberInputValidation(errors, required),
      errorMessage = _usePhoneNumberInputV.errorMessage,
      validateOnBlur = _usePhoneNumberInputV.validateOnBlur,
      validateOnChange = _usePhoneNumberInputV.validateOnChange,
      isError = _usePhoneNumberInputV.isError;

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (!disableValidation) {
      validateOnBlur(event);
    }
  };

  var handleChange = function handleChange(phoneNumber) {
    onChange(phoneNumber);

    if (!disableValidation) {
      validateOnChange();
    }
  };

  var _useMemo = useMemo(function () {
    var shouldShowError = !disableValidation && isError;
    return [forceShowError.outlineError || shouldShowError, forceShowError.inlineError || shouldShowError];
  }, [forceShowError, isError, disableValidation]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      showOutlineError = _useMemo2[0],
      showInlineError = _useMemo2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(getClassName({
      descendantName: "wrapper"
    }), className)
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(PhoneInput, _extends({
    className: getClassName({
      descendantName: "input",
      modifiers: showOutlineError && "isInvalid"
    }),
    id: id,
    onBlur: handleBlur,
    onChange: handleChange,
    value: value
  }, props)), showInlineError && /*#__PURE__*/React.createElement(InlineErrorMessage, {
    className: classNames(getClassName({
      descendantName: "error"
    })),
    errorMessage: errorMessage,
    id: "error-".concat(id)
  }));
};
PhoneNumberInput.displayName = "PhoneNumberInput";